// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './firebase-config.js';

// Import the functions you need from the SDKs you need


// Initialize Firebase
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
console.log("Got here")
